import { ContentBox } from "@msuite/ui/content-box";
import { LoadingScreen } from "@msuite/ui/loading-screen";
import { Panels } from "@msuite/ui/panels";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";
import { useParams } from "react-router";
import { ProjectHeader } from "@/components/projects";
import { client } from "@/hono";
import { useMemberBreadcrumbTitle } from "@/hooks/use-member-breadcrumb-title";
import Measurement from "@/sites/measurements/measurement";
import { ControllingMeasurementMenu } from "./controlling-measurement-menu";
import { columns } from "./table-config";

export function ControllingMeasurement() {
	const params = useParams();
	const projectId = params.projectId as string;

	/** Hooks */

	/** Query */
	const { data: project } = useQuery({
		queryKey: ["projects", guardString(projectId)],
		queryFn: async () => {
			const response = await client.projects[":projectId"].$get({
				param: { projectId },
			});
			const data = await responseHandler(response);
			return data.project;
		},
	});

	/** Effects */
	// The project names its own crumb through its header; the user it is measured for sits one
	// crumb above it.
	useMemberBreadcrumbTitle(params.userId);

	if (!project) return <LoadingScreen />;

	/** Render */
	return (
		<ContentBox>
			<ProjectHeader project={project} />
			<Panels>
				<Panels.Panel flex={1}>
					<Measurement
						type="controlling"
						columns={columns}
						menu={() => <ControllingMeasurementMenu />}
					/>
				</Panels.Panel>
			</Panels>
		</ContentBox>
	);
}
